import { createSelector } from 'reselect'

import { selectCockpitPeriods } from './selectCockpitPeriods'

/** Whether the dashboard is scoped to the year-to-date period. Drives YTD-specific behavior in
 *  the revenue-and-SOB tile: prorating the in-progress quarter for baseline/plan and hiding
 *  expected exit. */
export const selectIsCockpitYtd = createSelector([selectCockpitPeriods], (periods) =>
  periods.includes('ytd')
)
